import { useAppConfig } from '@plato/app-core/hooks/use-app-config';
import { useTenant } from '@plato/app-core/hooks/use-tenant';
import { useAnalytics } from '../../analytics/hooks/use-analytics.ts';

export type WebshopLink = {
    href: string;
    onClick: () => void;
};

/** The tenant's webshop as an external nav link, or `undefined` when the flag is off or no URL is configured. */
export function useWebshopLink(): WebshopLink | undefined {
    const { webshopUrl } = useTenant();
    const { enableWebshopNavLink } = useAppConfig();
    const sendEvent = useAnalytics();

    if (!enableWebshopNavLink || !webshopUrl) {
        return undefined;
    }

    return {
        href: webshopUrl,
        onClick: () => {
            sendEvent('webshop_opened', {
                source: 'side_menu',
                display_mode: window.matchMedia('(display-mode: standalone)').matches
                    ? 'standalone'
                    : 'browser',
            });
        },
    };
}
